// Remarkable PIA sections items
export const SECTION_ITEMS = {
    measures: { section: 3, item: 1},
    validate: { section: 4, item: 4},
    refuse: { section: 4, item: 5}
};
